import React from "react";
import {
  NotificationImage,
  NotificationNotifyImage,
  NotificationReadImage,
} from "../../../components/Icons";

const Notification = () => {
  return (
    <div className="mainNotificationPage">
      <div className="last7days">Last 7 days</div>

      <div className="notificationmaindiv">
        <div className="notificationbox">
          <div className="notificationread">
            <NotificationNotifyImage />
          </div>

          <div className="notificationimg">
            <NotificationImage />
          </div>

          <div className="notificationtitle">
            New Update: Policy Change – Incident Reporting
            <div className="notificationdescription">
              A new policy version has been released.
            </div>
            <div className="viewdetails">View Details</div>
          </div>
        </div>
      </div>

      <div className="notificationmaindiv">
        <div className="notificationbox">
          <div className="notificationread">
            <NotificationNotifyImage />
          </div>

          <div className="notificationimg">
            <NotificationImage />
          </div>

          <div className="notificationtitle">
            Updated Form: Staff Onboarding Checklist
            <div className="notificationdescription">
              Form updated with new compliance checks.
            </div>
            <div className="viewdetails">View Details</div>
          </div>
        </div>
      </div>

      <div className="notificationmaindiv">
        <div className="notificationbox">
          <div className="notificationread">
            <NotificationNotifyImage />
          </div>

          <div className="notificationimg">
            <NotificationImage />
          </div>

          <div className="notificationtitle">
            New Feature: AI Assistant for Policies
            <div className="notificationdescription">
              Explore the latest feature powered by AI – now available in your
              dashboard.
            </div>
            <div className="viewdetails">View Details</div>
          </div>
        </div>
      </div>

      <div className="last7days">Older</div>

      <div style={{ background: "none" }} className="notificationmaindiv">
        <div className="notificationbox">
          <div className="notificationimg">
            <NotificationImage />
          </div>

          <div className="notificationtitle">
            Legislation Update: NDIS Worker Screening
            <div className="notificationdescription">
              Changes reflect updated requirements from the NDIS Commission.
            </div>
            <div className="viewdetails">View Details</div>
          </div>
        </div>
      </div>

      <div style={{ background: "none" }} className="notificationmaindiv">
        <div className="notificationbox">
          <div className="notificationimg">
            <NotificationImage />
          </div>

          <div className="notificationtitle">
            Reminder: Annual Policy Review Due
            <div className="notificationdescription">
              Review your organization's compliance documents before May 1st.
            </div>
            <div className="viewdetails">View Details</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
